import { type StoreGroupsFormikValues } from './form.types'

export const NEW_STORE_GROUP_DEFAULTS: StoreGroupsFormikValues = {
  existingStoreGroupId: undefined,
  name: '',
  selectedLocationIds: [],
  retailerIds: [],
}
